var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactsInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "23px",
    viewBox: "0 0 26 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon / contacts") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chat",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "v40-212-1-copy",
    transform: "translate(-175.000000, -211.000000)",
    fill: "#5AA0FB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.519989,223.416598 C189.777734,223.416598 194.039978,227.753035 194.039978,233.102301 C194.039978,233.598086 193.638065,234 193.142279,234 L175.897699,234 C175.440051,234 175.062388,233.657541 175.006994,233.214906 L175,233.102301 C175,227.753035 179.262244,223.416598 184.519989,223.416598 Z M192.736775,222.167896 C197.300428,222.167896 201,225.931866 201,230.574958 C201,231.005294 200.651144,231.35415 200.220809,231.35415 L195.76859,231.353811 C195.208839,227.595042 192.872429,224.429529 189.657849,222.771404 C190.609164,222.381979 191.648396,222.167896 192.736775,222.167896 Z M184.52589,211 C187.288824,211 189.528625,213.278788 189.528625,216.089816 C189.528625,218.900844 187.288824,221.179633 184.52589,221.179633 C181.762956,221.179633 179.523156,218.900844 179.523156,216.089816 C179.523156,213.278788 181.762956,211 184.52589,211 Z M192.735307,211.472473 C195.133497,211.472473 197.077614,213.450432 197.077614,215.890367 C197.077614,218.330302 195.133497,220.30826 192.735307,220.30826 C191.889721,220.30826 191.100587,220.062357 190.433221,219.637003 C191.039327,218.598189 191.386183,217.385214 191.386183,216.089816 C191.386183,214.675027 190.972444,213.358555 190.261349,212.258808 C190.962842,211.76332 191.81569,211.472473 192.735307,211.472473 Z",
    id: "icon-/-contacts"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsInactive);
export default __webpack_public_path__ + "static/media/contacts_inactive.5a66da9b8717c3021df2a39ef459a271.svg";
export { ForwardRef as ReactComponent };